import { exportToExcel } from "utils/ExportToExcel";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";

const useExcelExport = ({ exportHook, fileName }) => {
    const dispatch = useDispatch();

    const [triggerExport, { isFetching }] = exportHook();

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleExport = async ( filters, formatData ) => {
        try {
            const exportFilters = {
                ...filters,
                PageNumber: 1,
                PageSize: 5000,
            };

            const response = await triggerExport(exportFilters).unwrap();

            const rows = response?.data || [];

            if (!Array.isArray(rows) || rows.length === 0) {
                openNotification("No data available to export", "warning");
                return;
            }

            const formattedData = formatData(rows);

            exportToExcel( formattedData, fileName );

            openNotification("Excel exported successfully", "success");
        } catch (error) {
            openNotification("Failed to export Excel", "error");
        }
    };

    return { handleExport, isExporting: isFetching };
};

export default useExcelExport;